import FeedBack from './lnk-feedback';

let $feedback = null;

export default {
    install(Vue){
        function getFeedBack(){
            if(!$feedback){
                $feedback = new Vue(FeedBack).$mount();
            }
            return $feedback;
        }
        Vue.prototype.$feedback = {
            show(){
                const ins = getFeedBack();
                document.body.appendChild(ins.$el);
                ins.openMissionDialog();
            },
            hide(){
                const ins = getFeedBack();
                ins.closeMissionDialog();
                if(!ins.$el.parentNode) return;
                ins.$el.parentNode.removeChild(ins.$el);
            }
        };
    }
};
